<template>
  <v-container>
    <v-dialog
      width="500"
      :value="isOpenQrcodeModal"
      @click:outside="isCloseQrcodeModal"
    >
      <VueQr
        :text="getUrl()"
        :logoSrc="centerLogo"
        :size="400"
        :logoCornerRadius="0"
        :correctLevel="1"
        backgroundDimming
        colorDark="purple"
        colorLight="white"
      ></VueQr>
      <v-btn @click="isCloseQrcodeModal">
        Close
      </v-btn>
    </v-dialog>
  </v-container>
</template>
<script>
import VueQr from 'vue-qr';
export default {
  data() {
    return {
      loading: false,
      modalState: 0,
      centerLogo: require("@/assets/vla_tips_logo.png"),
    };
  },
  name: 'QrcodeModal',
  props: [
    'isOpenQrcodeModal',
    'isCloseQrcodeModal',
    'topic'
  ], 
  components: {
    VueQr,
  },
  methods: {
    getUrl() {
      return process.env.VUE_APP_BASE_URL + '/topic/' + this.topic.topic_code;
    },
  },
}
</script>
<style scoped>
</style>